export enum CerteuropeSignMutationTypes {
    SET_SIGNING_VIEW_PENDING = 'SET_SIGNING_VIEW_PENDING',
    SET_SIGNING_VIEW = 'SET_SIGNING_VIEW',
    SET_SIGNING_VIEW_ERROR = 'SET_SIGNING_VIEW_ERROR',
    ADD_PAGES_NUMBER_PENDING = 'ADD_PAGES_NUMBER_PENDING',
    REMOVE_PAGES_NUMBER_PENDING = 'REMOVE_PAGES_NUMBER_PENDING',
    SET_PAGES = 'SET_PAGES',
    SET_PAGES_ERROR = 'SET_PAGES_ERROR',
    SET_ACTIVE_PAGE = 'SET_ACTIVE_PAGE',
    SET_SCROLL_TO = 'SET_SCROLL_TO',
    SET_SIGN_TAG_PENDING = 'SET_SIGN_TAG_PENDING',
    REMOVE_SIGN_TAG_PENDING = 'REMOVE_SIGN_TAG_PENDING',
    SET_SIGN_TAG_ERROR = 'SET_SIGN_TAG_ERROR',
    SET_UNSIGN_TAG_PENDING = 'SET_UNSIGN_TAG_PENDING',
    REMOVE_UNSIGN_TAG_PENDING = 'REMOVE_UNSIGN_TAG_PENDING',
    SET_UNSIGN_TAG_ERROR = 'SET_UNSIGN_TAG_ERROR',
    REFRESH_TAG = 'REFRESH_TAG',
    SET_VALIDATION_MODAL_IS_OPEN = 'SET_VALIDATION_MODAL_IS_OPEN',
    SET_SEND_VALIDATION_SMS_PENDING = 'SET_SEND_VALIDATION_SMS_PENDING',
    SET_SEND_VALIDATION_SMS_ERROR = 'SET_SEND_VALIDATION_SMS_ERROR',
    SET_SIGN_DOCUMENT_PENDING = 'SET_SIGN_DOCUMENT_PENDING',
    SET_SIGN_DOCUMENT_ERROR = 'SET_SIGN_DOCUMENT_ERROR',
    SET_RESEND_VALIDATION_SMS_PENDING = 'SET_RESEND_VALIDATION_SMS_PENDING',
    SET_RESEND_VALIDATION_SMS_ERROR = 'SET_RESEND_VALIDATION_SMS_ERROR',
    SET_CONFIRM_SIGNATURE_PENDING = 'SET_CONFIRM_SIGNATURE_PENDING',
    SET_CONFIRM_SIGNATURE_ERROR = 'SET_CONFIRM_SIGNATURE_ERROR',
    RESET = 'RESET',
}
